<template>
  <div class="mb-2">
    <b-form-group :label="fieldName">
      <div class="p-3 border rounded">
        <editor-menu-bar
          v-slot="{ commands, isActive }"
          :editor="editor"
          class="mb-4"
        >
          <div>
            <b-button
              class="mr-2"
              :variant="
                isActive.heading({ level: 1 }) ? 'primary' : 'outline-primary'
              "
              @click.stop.prevent="commands.heading({ level: 1 })"
            >
              <strong>H1</strong>
            </b-button>
            <b-button
              class="mr-2"
              :variant="
                isActive.heading({ level: 2 }) ? 'primary' : 'outline-primary'
              "
              @click.stop.prevent="commands.heading({ level: 2 })"
            >
              <strong>H2</strong>
            </b-button>
            <b-button
              class="mr-2"
              :variant="
                isActive.heading({ level: 3 }) ? 'primary' : 'outline-primary'
              "
              @click.stop.prevent="commands.heading({ level: 3 })"
            >
              <strong>H3</strong>
            </b-button>
            <b-button
              class="mr-2"
              :variant="isActive.bold() ? 'primary' : 'outline-primary'"
              @click.stop.prevent="commands.bold"
            >
              <strong>B</strong>
            </b-button>
            <b-button
              class="mr-2"
              :variant="isActive.ordered_list() ? 'primary' : 'outline-primary'"
              @click.stop.prevent="commands.ordered_list"
            >
              <font-awesome-icon :icon="faListOl" />
            </b-button>
            <b-button
              class="mr-2"
              :variant="isActive.bullet_list() ? 'primary' : 'outline-primary'"
              @click.stop.prevent="commands.bullet_list"
            >
              <font-awesome-icon :icon="faListUl" />
            </b-button>
          </div>
        </editor-menu-bar>
        <editor-content :editor="editor" />
      </div>
      <input v-model="value" name="other_fields" type="hidden" required />
    </b-form-group>
  </div>
</template>
<script>
import { faListUl, faListOl } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Heading,
  Bold,
  Italic,
  OrderedList,
  BulletList,
  ListItem
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    FontAwesomeIcon
  },
  props: {
    inputField: {
      type: String,
      required: false,
      default: null
    },
    fieldName: {
      type: String,
      required: true
    },
    disableProposal: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    inputField(text) {
      this.value = text
      let html = this.editor.getHTML()
      if (html !== this.value) {
        this.editor.setContent(this.value)
      }
    },
    disableProposal() {
      this.disableEditor()
    }
  },
  data: () => ({
    editor: null,
    value: null,
    faListOl,
    faListUl
  }),
  mounted() {
    this.setEditor()
    this.disableEditor()
  },
  methods: {
    setEditor() {
      this.value = this.inputField

      this.editor = new Editor({
        extensions: [
          new Heading({ levels: [1, 2, 3] }),
          new Bold(),
          new Italic(),
          new OrderedList(),
          new BulletList(),
          new ListItem()
        ],
        onUpdate: () => {
          this.value = this.editor.getHTML()
          this.$emit('updateInput', this.value)
        },
        content: this.value
      })
    },
    disableEditor() {
      if (this.disableProposal === true) {
        this.editor.setOptions({ editable: false })
      }
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>
